import MaintenanceTemplate from './MaintenanceTemplate.vue'
export default MaintenanceTemplate


// WEBPACK FOOTER //
// ./src/pages/MaintenanceTemplate/index.js